/* eslint-disable indent */

    var trackingUtils = require('../modules/utils/tracking.utils');
    Odigeo.defineWidget('residentdiscount', Odigeo.Widget.extend({
        modelClass: Odigeo.Model.extend({
            dataURL: 'getresidentzonesforitinerary',
            isResident: false,
            gapStatus: 'notAvailable',
            responseCache: {},
            kids: false,

            url: function() {
                return Odigeo.Settings.getProperty('coreUrlFormatter')(this.dataURL);
            },
            getCacheHash: function() {
                return this.widget.options.orig + '-' + this.widget.options.dest;
            },
            getDataRequestSettings: function() {
                var dataRequestSettings;
                var request = {
                    'departureIata': this.widget.options.orig,
                    'arrivalIata': this.widget.options.dest,
                };

                dataRequestSettings = {
                    type: 'GET',
                    dataType: 'json',
                    cache: false,
                    data: request,
                    success: Odigeo._.bind(this.requestSuccessHandler, this),
                    error: Odigeo._.bind(this.requestErrorHandler, this),
                };
                return dataRequestSettings;
            },

            requestSuccessHandler: function(data) {
                var cacheHash = this.getCacheHash();

                this.isResident = true;

                if (!Odigeo._.has(this.responseCache, cacheHash)) {
                    this.responseCache[cacheHash] = data;
                }

                if (!Odigeo._.isEmpty(data)) {
                    this.widget.responseIsOK(data);
                } else {
                    this.widget.responseIsKO();
                }
            },
            requestErrorHandler: function() {
                this.widget.responseIsKO();
            },
        }),

        viewClass: Odigeo.View.extend({
            init: function() {
                this.cacheDomSelectors();
                this.bindToDom();
            },
            cacheDomSelectors: function() {
                this.addSelectorToCache('residentBlock', this.$widget.find('.resident_discount_block'));
                this.addSelectorToCache('residentCheck', this.$widget.find('.resident_checkbox'));
                this.addSelectorToCache('residentCheckDesktop', this.$widget.find('#residentTrue, #residentFalse'));
                this.addSelectorToCache('resCheckedBox', this.$widget.find('.resident_box_info'));
                this.addSelectorToCache('resCheckedInfo', this.$widget.find('.resident_box_check'));
                this.addSelectorToCache('residentNoChild', this.$widget.find('.resident_child'));
                this.addSelectorToCache('residentLabel', this.$widget.find('.resident_label'));
                this.addSelectorToCache('residentResults', this.$widget.find('.resident_results'));

                // results
                this.addSelectorToCache('resultsTop', $('.resident_results_top'));
                this.addSelectorToCache('resultsApplied', $('.resident_applied'));
                this.addSelectorToCache('resultsHasChildren', $('.resident_has_children'));
            },
            bindToDom: function() {
                if (!this.isDomBinded) {
                    this.$cachedSelectors.residentCheck.on(Odigeo.Events.change, Odigeo._.bind(this.widget.updateResident, this.widget));
                    this.isDomBinded = true;
                }
            },
            unbindFromDom: function() {
                if (this.isDomBinded) {
                    this.$cachedSelectors.residentCheck.off(Odigeo.Events.change);
                    this.isDomBinded = false;
                }
            },
        }),
        updateResident: function() {
            var state = this.view.$cachedSelectors.residentCheck.is(':checked');
            this.view.$cachedSelectors['resCheckedBox'].toggleClass('odf-hidden', !state);
            Odigeo.trigger('updateSearchPanelTopPosition');
        },
        updatePaxResident: function(residentPaxDiv) {
            var kids = $('#kids').val();
            var infants = $('#infants').val();
            var $el = (residentPaxDiv instanceof $) ? residentPaxDiv : $(residentPaxDiv);
            $el.addClass('odf-hidden');
            this.view.$cachedSelectors.resCheckedBox.toggleClass('odf-hidden', true);
            if (this.options.resident && kids + infants > 0) {
                $el.removeClass('odf-hidden');
                this.view.$cachedSelectors.resCheckedBox.toggleClass('odf-hidden', false);
            }
        },
        checkResident: function(airports) {
            if (Odigeo._.isUndefined(airports) || Odigeo._.isEmpty(airports)) {
                airports = {
                    depIata: this.options.orig,
                    arrIata: this.options.dest,
                };
            }
            if (!airports.depIata || !airports.arrIata || airports.depIata === airports.arrIata) {
                return;
            }

            this.view.$cachedSelectors.residentCheck.prop('checked', '').trigger('change');
            this.options.orig = airports.depIata;
            this.options.dest = airports.arrIata;
            if (Odigeo._.has(this.model.responseCache, this.model.getCacheHash())) {
                this.model.requestSuccessHandler(this.model.responseCache[this.model.getCacheHash()]);
                return;
            }
            this.model.isEmptyData = false;
            this.model.refresh();
        },
        responseIsKO: function() {
            this.updateParams();
            Odigeo.trigger(this.model.widget.id + ':hideResident');
        },
        responseIsOK: function(data) {
            this.updateParams();
            Odigeo.trigger(this.model.widget.id + ':showResident', data);
        },
        // Return true if children are more than 0
        checkChildren: function() {
            var kids = $('#kids').val();
            var infants = $('#infants').val();

            return kids + infants > 0;
        },
        hideResidentInBlock: function() {
            this.view.$cachedSelectors.residentCheck.removeAttr('disabled');
            this.view.$cachedSelectors.residentCheck.prop('checked', '').trigger('change');
            this.view.$cachedSelectors.resCheckedInfo.addClass('odf-hidden');
            this.view.$cachedSelectors.residentNoChild.addClass('odf-hidden');
            this.view.$cachedSelectors.residentLabel.removeClass('hidden');
            this.view.$cachedSelectors.residentResults.addClass('hidden');
            this.view.$cachedSelectors.residentBlock.addClass('odf-hidden');

            this.model.departureIATA = '';
            this.model.arrivalIATA = '';
            this.model.isResident = false;
            this.model.gapStatus = 'notAvailable';
            this.updateParams();
        },
        showResidentInBlock: function(params) {
            var type = '';
            var i;
            this.view.$cachedSelectors.residentCheck.removeAttr('disabled');
            this.view.$cachedSelectors.residentBlock.removeClass('odf-hidden');
            if (this.checkChildren()) {
                this.view.$cachedSelectors.residentCheck.prop('disabled', 'disabled');
                this.view.$cachedSelectors.residentCheck.parent().siblings('label')
                    .addClass('od-residentDiscount-label-greyed');
                this.view.$cachedSelectors.resCheckedInfo.addClass('odf-hidden');
                this.view.$cachedSelectors.residentNoChild.removeClass('odf-hidden');
                this.view.$cachedSelectors['residentLabel'].addClass('hidden');
                this.model.gapStatus = 'disabledChildren';
            } else {
                this.view.$cachedSelectors.residentResults.removeClass('hidden');
                this.view.$cachedSelectors.resCheckedInfo.removeClass('odf-hidden');
                this.view.$cachedSelectors.residentNoChild.addClass('odf-hidden');
                this.view.$cachedSelectors.residentLabel.removeClass('hidden');
                this.view.$cachedSelectors.residentCheck.parent().siblings('label')
                    .removeClass('od-residentDiscount-label-greyed');
                this.model.gapStatus = 'available';
            }
            if (params.length === 1) {
                type = params[0].toLowerCase();
            } else {
                type = params[0].toLowerCase();
                for (i = 1; i < params.length; i++) {
                    type += ' <span>o</span> ' + params[i].toLowerCase();
                }
            }
            $('#resident_city').html(type).parent('label');
            this.model.isResident = true;
            this.updateParams();
        },
        hideResidentPage: function() {
            this.model.gapStatus = 'notAvailable';
            this.model.isResident = false;
            this.updateParams();
        },
        showResidentPage: function(params) {
            var type = '';
            var zones = Odigeo._.map(params, function(string) {
                return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
            });

            if (params.length === 1) {
                type = Odigeo._.first(zones);
            } else {
                type = Odigeo._.initial(zones).join(', ') + ' <span>o</span> ' + Odigeo._.last(zones);
            }

            $('.resident_type').html(type);

            this.model.gapStatus = 'available_desktop';
            this.model.isResident = true;
            this.updateParams();
        },
        toggleResidentsInfoBlocks: function(options) {
            var self = this;
            $.each(options.blocks, function(idx, val) {
                self.view.$cachedSelectors[val].toggleClass('hidden', options.state);
            });
        },
        checkEnabled: function(isResident) {
            this.view.$cachedSelectors.residentCheck.prop('checked', isResident).trigger('change');
        },

        residentAnalytics: function() {
            var labelTracking = null;

            switch (this.options.status) {
                case 'disabledChildren':
                    labelTracking = 'not_available_kids';
                    break;

                case 'available':
                    labelTracking = this.view.$cachedSelectors.residentCheck.is(':checked') ? 'YES' : 'NO';
                    break;

                case 'available_desktop':
                    labelTracking = this.view.$cachedSelectors.residentCheckDesktop.filter(':checked').val() === 'resident' ? 'YES' : 'NO';
                    break;
            }

            if (!Odigeo._.isNull(labelTracking)) {
                trackingUtils.trackEvent('residents_widget', 'all_pax_residents_' +
                    labelTracking, Odigeo.History.getPageNameFromFragment());
            }
        },
        updateParams: function() {
            this.options.resident = this.model.isResident;
            this.options.status = this.model.gapStatus;
        },
        initParams: function(data) {
            this.options.orig = data.depIata;
            this.options.dest = data.arrIata;
            this.options.resident = data.resident;
            this.options.status = (data.resident) ? 'available' : 'notAvailable';

            if (this.options.resident) {
                Odigeo.trigger(this.model.widget.id + ':showResident');
            } else {
                Odigeo.trigger(this.model.widget.id + ':hideResident');
            }
        },
        execute: function(func, params) {
            switch (func) {
                case 'checkResident':
                    this.checkResident(params);
                    break;
                case 'residentAnalytics':
                    this.residentAnalytics(params);
                    break;
                case 'updatePaxResident':
                    this.updatePaxResident(params);
                    break;
                case 'initParams':
                    this.initParams(params);
                    break;
                case 'showResidentInBlock':
                    this.showResidentInBlock(params);
                    break;
                case 'hideResidentInBlock':
                    this.hideResidentInBlock(params);
                    break;
                case 'showResidentPage':
                    this.showResidentPage(params);
                    break;
                case 'hideResidentPage':
                    this.hideResidentPage(params);
                    break;
                case 'toggleResidentsInfoBlocks':
                    this.toggleResidentsInfoBlocks(params);
                    break;
                case 'checkEnabled':
                    this.checkEnabled(params);
                    break;
            }
            return this;
        },

        departureIATA: '',
        arrivalIATA: '',
        gapStatus: 'notAvailable',
        isResident: false,
    }));
